export default __webpack_public_path__ + "static/media/7.a3e3e773.jpg";